import type { IconData } from '@stacksjs/iconify-core'

export const basicUiDownload: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M11 0H5v4H1l7 7l7-7h-4zm5 13v3H0v-3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiDownload
